/**
 * Restores the `targeted_content_clicked` GA event that the prerendered campaign
 * markup fired from inline `onclick` handlers on the thumbnail and title links
 * (see `video/v2025_12_1/video_item_short.html`).
 *
 * Featured video campaigns now render an inline `<vm-video-card-related>`
 * (`includes/featured_campaign_card.html`), whose links live in shadow DOM and so
 * cannot carry a template-written `onclick`. Clicks are instead caught on the card
 * host — shadow-DOM clicks bubble out retargeted to it — and the video id comes
 * from the card's `data-video-id`.
 *
 * Bound per card rather than on `.js_relatedCampaignsWrap` so it also covers the
 * channel content-type pages, which render the same partial without that wrapper.
 * Non-video campaigns keep their prerendered markup and are not matched here.
 */
export const trackCampaignVideoClicks = () => {
    document.querySelectorAll<HTMLElement>('.js_campaignVideoCard').forEach((card) => {
        if (card.dataset.gtagInitialized === 'true') return;
        card.dataset.gtagInitialized = 'true';

        card.addEventListener('click', () => {
            const videoId = card.dataset.videoId;
            if (!videoId) return;

            window.gtag?.('event', 'targeted_content_clicked', {
                event_category: 'Clicks',
                event_label: videoId,
            });
        });
    });
};
